(function() {
    'use strict';
    var EmploymentCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel) {
        console.log("Inside EmploymentCtrl");
        $scope.careerModel = {};
        $scope.careerModel.errorMessageVal = '';
        $scope.careerModel.errorMessage = false;
        $scope.careerModel.disableAddBtn = false;
        $scope.ngModel = passedModel;

        $scope.resetFormData = function(){
            $scope.careerModel.organisation = '';
            $scope.careerModel.position = '';
            $scope.careerModel.description = '';
            $scope.careerModel.toDate = '';
            $scope.careerModel.fromDate = '';
            $scope.careerModel.untilPresent = false;
            $scope.careerModel.employmentHistoryId = -1;
            $scope.careerModel.voluntaryWork = false;
            $scope.careerModel.selfEmployment = false;
            $scope.careerModel.claimingBenefits = false;
            $scope.careerModel.unemploymentBenefitsType = '';
            $scope.careerModel.unemploymentReason = '';
            $scope.careerModel.unemploymentSupport = '';
            $scope.careerModel.careerBreakReason = '';
            $scope.careerModel.travelDestination = '';
            $scope.careerModel.referee = {};
            $scope.careerModel.referee.position  = '';
            $scope.careerModel.referee.firstName = '';
            $scope.careerModel.referee.lastName = '';
            $scope.careerModel.referee.contactTime = "5273";
            $scope.careerModel.referee.phone = '';
            $scope.careerModel.referee.email = '';
            $scope.careerModel.referee.postalAddress  = '';
            $scope.careerModel.referee.reasonsForLeaving = '';
            $scope.careerModel.referee.refereeDismissed = '';
            $scope.careerModel.referee.businessName = '';
            $scope.careerModel.referee.candReferenceConsent = '';
            $scope.careerModel.type = '';
            $scope.careerModel.registrationNumber = '';
            if($scope.careerModel.subjectModel) {
                $scope.careerModel.subjectModel.length = 0;
            }
            $scope.careerModel.educationHistoryId = -1;
            $scope.careerModel.itemDisplayConfigId = -1;
        }

        $scope.ajaxCallList = function(ajaxUrl, data, closePop, useFormData) {
            var errorMsg = 'Error';
            console.log("ajaxCallList", "ajaxUrl: ", ajaxUrl, "data: ", data, closePop, useFormData);
            ajaxCall.getData(ajaxUrl, data, useFormData).then(function(result) {
                console.log("employment ctrl first function", result)
                $scope.careerModel.disableAddBtn = false;
                $scope.careerModel.successMsg="Success";
                var count = $scope.ngModel.count;
                $scope.ngModel = result.data;
                $scope.ngModel.count = count+1;
               if(closePop == true){
                    $uibModalInstance.close($scope.ngModel);
               } else {
                    $scope.careerModel.employmentType = '';
                    $scope.careerModel.showType = true;
                    $scope.resetFormData();
               }

            }, function(result) {
                console.log("employment ctrl second function", result)
                $scope.careerModel.disableAddBtn = false;
                $scope.careerModel.errorMessage = true;
                $scope.careerModel.errorMessageVal = errorMsg;
            });
        }

        $scope.employmentSaveNg = function($event, closePop, controllerName) {

            console.log("employmentSaveNg...", "event: ", $event, "close pop: ", closePop, "controller name: ", controllerName, "$scope.careerModel: ", $scope.careerModel);
            var isValid = this.employmentPopupForm.$valid;
            console.log("is valid: ", isValid)
            if(isValid){
                $event.preventDefault();
                $scope.careerModel.disableAddBtn = true;
                var data = $scope.careerModel;
                var ajaxUrl = WEBAPP_PATH + "/"+controllerName+"/saveEmployment";
                $scope.ajaxCallList(ajaxUrl , data, closePop, true);
            }
        }

         $scope.employmentDelete = function($event, closePop) {
            $event.preventDefault();
            var data = $scope.careerModel;
            var ajaxUrl = WEBAPP_PATH + "/candidate/confirmDeleteEmployment";
            $scope.ajaxCallList(ajaxUrl , data, true, false);
        }

        $scope.untilPresentClick = function($event) {
            if($scope.careerModel.untilPresent == true){
                $scope.careerModel.toDate = "";
            }
        }
        $scope.clearRefereeClick = function($event) {
           if($scope.careerModel.nonMyBusiness == false){
               $scope.careerModel.referee.position = "";
               $scope.careerModel.referee.firstName = "";
               $scope.careerModel.referee.lastName = "";
               $scope.careerModel.referee.email = "";
               $scope.careerModel.referee.phone = "";
               $scope.careerModel.referenceContactCompany = "";
               $scope.careerModel.preVerifiedContactWarning = false;
            }
        }

        $scope.closePop = function($event) {
            $uibModalInstance.close($scope.ngModel);
        }
        $scope.cancel = function() {
            $uibModalInstance.close($scope.ngModel);
        };
        $scope.claimingBenefitsClick = function($event) {
            if($scope.careerModel.claimingBenefits == true){
                $scope.careerModel.unemploymentSupport = "";
            }else{
                $scope.careerModel.unemploymentBenefitsType = "";
                $scope.careerModel.organisation = "";
            }
        }
        $scope.selfEmploymentClick = function($event) {
            if($scope.careerModel.selfEmployment != true){
                $scope.careerModel.referee.businessName = "";
            }else{
                $scope.careerModel.referee.position = '';
            }
            $scope.careerModel.referee.firstName = '';
            $scope.careerModel.referee.lastName = '';
        }
        $scope.employmentTypeClick = function($event) {
            if(angular.isUndefined($scope.careerModel.employmentType)) {
                $scope.careerModel.employmentType = '';
            }
            $scope.careerModel.successMsg = '';
            $scope.resetFormData();
        }

        $scope.saveEducationNg = function($event, closePop, controllerName) {
            var isValid = this.employmentPopupForm.$valid;
            if(isValid){
                $event.preventDefault();
                $scope.careerModel.disableAddBtn = true;
                var data = $scope.careerModel;
                var ajaxUrl = WEBAPP_PATH +  "/"+controllerName+"/saveEducation";
                $scope.ajaxCallList(ajaxUrl , data, closePop, true);
            }
        }
        $scope.educationDelete = function($event, closePop) {
            $event.preventDefault();
            var data = $scope.careerModel;
            var ajaxUrl = WEBAPP_PATH + "/candidate/confirmDeleteEducation";
            $scope.ajaxCallList(ajaxUrl , data, true, false);
        }

        $scope.educationGapClick = function($event) {
            if($scope.careerModel.educationGap == true){
                $scope.careerModel.organisation = "Education Gap";
            } else {
                $scope.careerModel.organisation = "";
            }
        }
    };

    EmploymentCtrl.$inject = ['$scope', '$compile', '$uibModalInstance', 'ajaxCall', 'params'];
    angular.module('app').controller('EmploymentCtrl', EmploymentCtrl);
}());